/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edit/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Edit({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Title/Edit",
  onChange
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let taskTitleTitleValueData = fromData.useDataValue({ viewPath,
context: 'task_title',
path: 'title',
})
let taskTitleTitleChangeData = fromData.useDataChange({ viewPath,
context: 'task_title',
path: 'title',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onChange
  
})
  return (<React.Fragment
>
<div
  data-testid="Edit.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={0}
 size="medium"
 backgroundColor="white"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
/>
<TysiaTextareaLabel
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Title"
 required={true}
/>
<TysiaTextareaContent
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 data="task_title.title"
 value={taskTitleTitleValueData}
 onChange={taskTitleTitleChangeData}
 height="auto"
/>
)}
</TysiaTextareaContent>
<div
  data-testid="Edit.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-9u9G': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--g-2-9u9G': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 size="small"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Save"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
</div>
</div>
{children}
</React.Fragment>)
}